import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Kay Cesena",
    role: "Home Seller · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=240&h=240&fit=crop",
    quote: "Mary came highly recommended, and it didn't take long to understand why. Her professionalism and genuine care for her clients makes her by far the best real estate agent I have ever worked with. I could not be happier with the work Mary has done.",
    location: "Orange County, CA",
  },
  {
    name: "Ilia Ovsiannikov",
    role: "Home Buyer · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=240&h=240&fit=crop",
    quote: "Mary was our agent when myself and my wife needed to buy a house. That house received many competitive bids and Mary helped us win the competition (as well as negotiate post-offer-acceptance issues with house inspection results).",
    location: "Orange County, CA",
  },
  {
    name: "Janet Meadows",
    role: "Estate Client · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=240&h=240&fit=crop",
    quote: "Everything about working thru both my father-in-law's and my parents' estate was difficult, EXCEPT for the sale of real estate. Thank goodness Mary Nguyen had been recommended to us. She is calm, informed, infinitely patient, and a joy to work with.",
    location: "Orange County, CA",
  },
  {
    name: "Ann Christopherson",
    role: "Awesome Agent · 5.0 stars",
    photo: "https://images.pexels.com/photos/7479641/pexels-photo-7479641.jpeg?auto=compress&cs=tinysrgb&w=240&h=240",
    quote: "Mary is the consummate professional in every respect. She is thorough, extremely well prepared and knowledgeable in all areas of Southern California real estate.",
    location: "Southern California",
  },
  {
    name: "Joey Elgin",
    role: "My Exodus From Southern California · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1614289371518-722f2615943d?w=240&h=240&fit=crop",
    quote: "So in the year 2020 my family and I decided to leave Southern California for all the reasons — and Mary made a transition that could have been overwhelming feel completely handled from beginning to end.",
    location: "Southern California",
  },
  {
    name: "Robert Howell",
    role: "Probate Attorney · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=240&h=240&fit=crop",
    quote: "I am a probate attorney and have used Mary several times to assist in selling homes associated with my trusts and probates. She has been excellent!! My clients have had nothing but praise for her professional and personal service. She is knowledgeable about the probate process and always goes the extra mile.",
    location: "Orange County, CA",
  },
  {
    name: "Daniel Estrada",
    role: "Wonderful Experience Selling Condo Through Probate · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=240&h=240&fit=crop",
    quote: "Mary was very attentive to my needs. She has a great work ethic and kept me informed about the step by step processes of selling my condo. She has a positive attitude throughout the entire transaction.",
    location: "Southern California",
  },
  {
    name: "Tim Castoreale",
    role: "Fellow Real Estate Agent · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=240&h=240&fit=crop",
    quote: "I am a real estate agent and have been on the other side of two transactions with Mary. Mary always presented herself in a professional manner, was knowledgeable, responsive and represented her clients well. Every transaction I have been part of with Mary has been smooth.",
    location: "Orange County, CA",
  },
  {
    name: "Sashika De Silva",
    role: "Home Seller · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=240&h=240&fit=crop",
    quote: "Mary is professional and very passionate about her work! She is dedicated to her work and has a vast knowledge in Real Estate. Can't go wrong working with her! :)",
    location: "Orange County, CA",
  },
  {
    name: "Annie Nguyen",
    role: "Home Seller · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=240&h=240&fit=crop",
    quote: "Thank you Mary for helping me selling my house. I appreciate the late night communications we had and all the answers to my questions. The process was better and less stressful with your help and support. Best wishes to you!",
    location: "Orange County, CA",
  },
  {
    name: "Bolsa Lốc Cốc Tiên Sinh",
    role: "Probate Sale Client · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=240&h=240&fit=crop",
    quote: "I highly recommend Mary Nguyen for anyone buying or selling a home, especially if it involves a probate sale. Her guidance made the process feel simple, and she was always available when I needed her.",
    location: "Orange County, CA",
  },
  {
    name: "David Peel",
    role: "Verified Google Reviewer · 5.0 stars",
    photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=240&h=240&fit=crop",
    quote: "Five stars for Mary and the Probate Solution OC team — read the full review on our Google Business Profile.",
    location: "Orange County, CA",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const total = REVIEWS.length;
  const next = () => setI((p) => (p + 1) % total);
  const prev = () => setI((p) => (p - 1 + total) % total);
  const r = REVIEWS[i];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 sm:py-32 bg-navy-50/50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-4">
            <span className="section-overline">Family Stories</span>
            <h2 className="mt-3 font-heading text-4xl sm:text-5xl text-navy-900 leading-tight tracking-tight">
              Spoken from the <em className="italic text-gold-600">heart</em>.
            </h2>
            <p className="mt-4 text-navy-600 max-w-sm">
              Real words from real families we&apos;ve walked beside through one of
              life&apos;s most delicate seasons.
            </p>

            <a
              href="https://www.google.com/search?q=Probate+Solution+OC+Mary+Nguyen+reviews"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-badge"
              className="mt-6 inline-flex items-center gap-3 rounded-full glass px-4 py-2.5 hover:-translate-y-0.5 hover:shadow-lg transition-all"
            >
              <div className="flex items-center gap-1">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} size={14} className="fill-gold-500 text-gold-500" />
                ))}
              </div>
              <span className="text-sm font-semibold text-navy-900">
                {total} <span className="text-navy-500 font-medium">Verified Google Reviews</span>
              </span>
            </a>

            <div className="mt-8 flex items-center gap-3">
              <button
                onClick={prev}
                data-testid="testimonial-prev"
                className="h-12 w-12 rounded-full border border-navy-200 flex items-center justify-center text-navy-700 hover:bg-navy-900 hover:text-white hover:border-navy-900 transition-all"
                aria-label="Previous"
              >
                <ChevronLeft size={18} />
              </button>
              <button
                onClick={next}
                data-testid="testimonial-next"
                className="h-12 w-12 rounded-full bg-navy-900 text-white flex items-center justify-center hover:bg-gold-600 transition-all"
                aria-label="Next"
              >
                <ChevronRight size={18} />
              </button>
              <div className="ml-3 text-sm text-navy-600 font-medium">
                {String(i + 1).padStart(2, "0")} <span className="text-navy-300">/</span> {String(total).padStart(2, "0")}
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <AnimatePresence mode="wait">
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                data-testid="testimonial-card"
                className="relative glass rounded-3xl p-8 sm:p-12"
              >
                <Quote size={48} className="absolute top-8 right-8 text-gold-500/20" />
                <div className="flex items-center gap-1 mb-6">
                  {[0,1,2,3,4].map((s) => (
                    <Star key={s} size={18} className="fill-gold-500 text-gold-500" />
                  ))}
                </div>
                <p className="font-heading text-2xl sm:text-3xl text-navy-900 leading-snug italic">
                  "{r.quote}"
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <img src={r.photo} alt={r.name} className="h-14 w-14 rounded-full object-cover border-2 border-gold-500/40" />
                  <div>
                    <div className="font-semibold text-navy-900">{r.name}</div>
                    <div className="text-xs text-navy-600">{r.role} · {r.location}</div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
